import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from 'sweetalert2';
import "../../scss/card.css"
import { CModal } from '@coreui/react';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteSubTopicMaster = () => {
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    const instituteMasterId = localStorage.getItem("instituteMasterId")

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        instituteSyllabusStructureMasterId: '',
        instituteLessonMasterId: '',
        instituteTopicMasterId: '',
        instituteSubTopicName: '',
        details: '',
        instituteSubjectMasterId: ''
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subtopicData, setSubtopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [subjectList, setSubjectList] = useState([])
    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState("")

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [syllabusStructureNameSort, setSyllabusStructureNameSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);
    const [topicNameSort, setTopicNameSort] = useState(null);
    const [subTopicNameSort, setSubTopicNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["instituteSyllabusStructureMasterDetails.instituteSyllabusStructureName", "instituteSubjectMasterDetails.subjectName", "instituteLessonMasterDetails.instituteLessonName", "instituteTopicMasterDetails.instituteTopicName", "instituteSubTopicName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getSubtopicList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (subtopicData.instituteSyllabusStructureMasterId.length !== 0 && subtopicData.instituteSubjectMasterId !== '') {
                setSubtopicList(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(subtopicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(subtopicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > subtopicList.length) {
            endIndex = subtopicList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(subtopicList.slice(startIndex, endIndex));
    }, [subtopicList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = `/get-institute-sub-topic-master?instituteMasterId=${instituteMasterId}&`;
        if (subtopicData.instituteSyllabusStructureMasterId) {
            apiUrl += `syllabusStructureId=${subtopicData.instituteSyllabusStructureMasterId}&`;
        }

        if (subtopicData.instituteSubjectMasterId) {
            apiUrl += `instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&`;
        }

        if (subtopicData.instituteLessonMasterId) {
            apiUrl += `instituteLessonMasterId=${subtopicData.instituteLessonMasterId}&`;
        }

        if (subtopicData.instituteTopicMasterId) {
            apiUrl += `instituteTopicMasterId=${subtopicData.instituteTopicMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        if (subtopicData.instituteSyllabusStructureMasterId.length !== 0 && subtopicData.instituteSubjectMasterId !== '') {
            getSubtopicList();
        }
    }, [subtopicData.instituteSyllabusStructureMasterId, subtopicData.instituteSubjectMasterId, subtopicData.instituteLessonMasterId, subtopicData.instituteTopicMasterId]);

    const getSubtopicList = async () => {
        try {
            const response = await authorizedAxiosInstitute.get(getApiUrl());
            setSubtopicList(response.data.result);
        } catch (error) {
            setSubtopicList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const handleInputChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleDetailChange = (editor) => {
        let value = editor.getData();
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                details: value
            }
        })
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `get-institute-syllabus-structure?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubjectMasterId: '',
                instituteLessonMasterId: '',
                instituteTopicMasterId: ''
            }
        })
        const apiUrl = `get-institute-syllabus-structure-Wise-institute-subjects?id=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteLessonMasterId: '',
                instituteTopicMasterId: ''
            }
        })

        const apiUrl = `get-institute-subject-wise-institute-lesson?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${subtopicData.instituteSyllabusStructureMasterId}&instituteSubjectMasterId=${e.target.value}`
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteTopicMasterId: ''
            }
        })
        const apiUrl = `/get-institute-lesson-wise-institute-sub-topic?id=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(subtopicData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(subtopicData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [subtopicData])

    const addTopic = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-institute-sub-topic-master`;
                const response = await authorizedAxiosInstitute.post(apiUrl, subtopicData);
                await getSubtopicList();
                setSubtopicData((prevData) => {
                    return {
                        ...prevData,
                        instituteSubTopicName: '',
                        details: ''
                    }
                })
                setSaveId(response.data.result[0].id);
                setSyllabusStructureNameSort(null);
                setSubjectSort(null);
                setLessonNameSort(null);
                setTopicNameSort(null);
                setSubTopicNameSort(null);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(subtopicData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteSubtopic = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-sub-topic-master?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, subtopicList.length);
                await getSubtopicList();
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateSubtopic = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-institute-sub-topic-master?id=${editId}`;
            const response = await authorizedAxiosInstitute.put(apiUrl, subtopicData);
            await getSubtopicList();
            setSaveId(response.data.result[0].id);
            setEditId(null);
            setSubtopicData((prevData) => {
                return {
                    ...prevData,
                    instituteSubTopicName: '',
                    details: ''
                }
            })
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    loader.file.then((file) => {
                        body.append("file", file);
                        const apiUrl = "uploadimage";
                        authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                            .then((res) => {
                                resolve({ default: res.data.result });
                            })
                            .catch((err) => {
                                reject(err?.response?.data?.error);
                            });
                    });
                });
            },
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    const reset = () => {
        setSubtopicData(initialFormState);
        setSubtopicList([])
        setEditId('')
    }

    useEffect(() => {
        if (syllabusStructureNameSort == true || syllabusStructureNameSort == false) {
            setSubjectSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [syllabusStructureNameSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setSyllabusStructureNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [lessonNameSort])

    useEffect(() => {
        if (topicNameSort == true || topicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
            setSubTopicNameSort(null);
        }
    }, [topicNameSort])

    useEffect(() => {
        if (subTopicNameSort == true || subTopicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
        }
    }, [subTopicNameSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Institute Sub Topic Master</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-info"></i> Institute Sub Topic Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteSyllabusStructureMasterId' onChange={handleSyllabusChange} value={subtopicData.instituteSyllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.instituteSyllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSyllabusStructureMasterId && <p style={{ color: 'red' }}>{error.instituteSyllabusStructureMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChange} value={subtopicData.instituteSubjectMasterId.toString()}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteLessonMasterId' onChange={handleLessonChange} value={subtopicData.instituteLessonMasterId.toString()}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.instituteLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteLessonMasterId && <p style={{ color: 'red' }}>{error.instituteLessonMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteTopicMasterId' onChange={handleInputChange} value={subtopicData.instituteTopicMasterId.toString()}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.instituteTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteTopicMasterId && <p style={{ color: 'red' }}>{error.instituteTopicMasterId}</p>}
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className="col-md-12">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Sub Topic Name :</label>
                                                    <input required type="text" className="form-control" id="instituteSubTopicName" name='instituteSubTopicName' onChange={handleInputChange} value={subtopicData.instituteSubTopicName} />
                                                    {error.instituteSubTopicName && <p style={{ color: 'red' }}>{error.instituteSubTopicName}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Sub Topic Details :</label>
                                                    <CKEditor
                                                        editor={ClassicEditor}
                                                        data={subtopicData.details}
                                                        onReady={editor => {
                                                            console.log('Editor is ready to use!', editor);
                                                        }}
                                                        onChange={(event, editor) => {
                                                            handleDetailChange(editor)
                                                        }}
                                                        config={{
                                                            extraPlugins: [uploadPlugin],
                                                        }}
                                                        onInit={(editor) => {
                                                            uploadPlugin(editor);
                                                        }}
                                                    />
                                                    {error.details && <p style={{ color: 'red' }}>{error.details}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addTopic}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={reset}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSubtopic} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <CModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    aria-labelledby="LiveDemoExampleLabel"
                                                    onIni
                                                >
                                                    <div className="book book-modal">
                                                        <div className='table-header-like'> Sub Topic Details</div>
                                                        <div className="page" dangerouslySetInnerHTML={{ __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData}</div>` }}></div>
                                                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                            Close
                                                        </button>
                                                    </div>
                                                </CModal>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Structure Name
                                                                            <SortIcon sortState={syllabusStructureNameSort} setSortState={setSyllabusStructureNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"instituteSyllabusStructureMasterDetails.instituteSyllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"instituteLessonMasterDetails.instituteLessonName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Topic Name
                                                                            <SortIcon sortState={topicNameSort} setSortState={setTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"instituteTopicMasterDetails.instituteTopicName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Sub Topic Name
                                                                            <SortIcon sortState={subTopicNameSort} setSortState={setSubTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"instituteSubTopicName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((subtopic, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{subtopic?.instituteSyllabusStructureMasterDetails?.instituteSyllabusStructureName}</td>
                                                                                        <td>{subtopic?.instituteSubjectMasterDetails?.subjectName}</td>
                                                                                        <td>{subtopic?.instituteLessonMasterDetails?.instituteLessonName}</td>
                                                                                        <td>{subtopic?.instituteTopicMasterDetails?.instituteTopicName}</td>
                                                                                        <td>{subtopic?.instituteSubTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn-outline-warning edit_icon" title='Coming Soon...' disabled type="button" onClick={() => {
                                                                                                setSubtopicData({
                                                                                                    instituteMasterId: instituteMasterId,
                                                                                                    details: subtopic.details,
                                                                                                    instituteSubTopicName: subtopic.instituteSubTopicName,
                                                                                                    instituteLessonMasterId: subtopic.instituteLessonMasterDetails?.id,
                                                                                                    instituteTopicMasterId: subtopic.instituteTopicMasterDetails?.id,
                                                                                                    instituteSyllabusStructureMasterId: subtopic.instituteSyllabusStructureMasterDetails?.id,
                                                                                                    instituteSubjectMasterId: subtopic.instituteSubjectMasterDetails.id
                                                                                                });
                                                                                                setEditId(subtopic.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setVisible(!visible)
                                                                                                setModalData(subtopic.details)
                                                                                            }}><i class="fa fa-eye" ></i></button>
                                                                                            <button className="btn-outline-danger delete_icon" title='Coming Soon...' disabled type="button" /*disabled={editId === subtopic.id}*/ onClick={() => deleteSubtopic(subtopic.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Sub Topic Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={subtopicList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteSubTopicMaster;